import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setReload,
    setModalOpen,
    setSelectedItem,
    setCurrentPage,
    setActionType,
    setSelectedItems,
    setAllChecked
} from 'store/ResponseTemplate/actions';
import { Button, Typography, Box, Grid, Stack } from '@mui/material';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import { useMutation } from '@apollo/client';
import { UPDATE_QUESTION_REGISTRY } from 'schemas/mutation';
import TrashIcon from 'Components/Icons/TrashIcon';
function DeleteResponseTemplate() {
    const dispatch = useDispatch();
    const { companyData } = useSelector((params) => params.customization);
    const { selectedItem, reload, typeOfAction, userSelectedItems } = useSelector((params) => params.response);
    const handleClose = () => dispatch({ type: setModalOpen, modalOpen: false });
    const [deleteMutation] = useMutation(UPDATE_QUESTION_REGISTRY);
    const handleSoftDelete = async () => {
        dispatch({ type: SET_LOADING, loading: true });
        dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });
        let registryIdsInput = [];
        if (typeOfAction === 'A') {
            dispatch({ type: setSelectedItems, userSelectedItems: [] });
            dispatch({ type: setAllChecked, isAllChecked: false });
            registryIdsInput = [...userSelectedItems.map((item) => item._id)];
        } else {
            registryIdsInput = [selectedItem._id];
        }
        let variables = {
            editQuestionRegistryInput: {
                companyId: companyData._id,
                status: 'deleted',
                questionRegistryIds: registryIdsInput
            }
        };
        try {
            await deleteMutation({ variables: { ...variables } });
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'success',
                    message: 'Question deleted successfully'
                }
            });
            dispatch({ type: setModalOpen, modalOpen: false });
            dispatch({ type: setActionType, typeOfAction: '' });
            dispatch({ type: setReload, reload: !reload });
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'error',
                    message: e.message || 'Something went wrong while trying to delete the question registry. Please try again later'
                }
            });
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
            dispatch({ type: setSelectedItem, selectedItem: null });
        }
    };
    return (
        <>
            {/* <Box className="modal-hero">
                <img src={AnnouncementImage} alt="announcement" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    Are you sure you want to delete this?
                </Typography>
                <Typography variant="p" component="p">
                    {typeOfAction !== 'A'
                        ? 'This question will be completely removed from your question registry.'
                        : 'These questions will be completely removed from your question registry.'}
                </Typography>
            </Box>
            <Box className="modal-footer pt-0">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Button variant="outlined" className="alternate-reversed w-full" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button variant="contained" className="alternate w-full" onClick={handleSoftDelete}>
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            </Box> */}
            <Stack gap={4}>
                <Typography variant="h6" component="h2" color="#00214D" fontSize="1.25rem" fontWeight="400" fontFamily="Poppins">
                    {typeOfAction !== 'A' ? 'Delete this question?' : 'Delete all selected questions?'}
                </Typography>
                <Typography component="p" fontSize="0.875rem" color="#00214D">
                    {typeOfAction !== 'A'
                        ? ''
                        : 'All selected questions will move to the Deleted tab. Questions in the Deleted tab for over 60 days will be permanently removed and cannot be recovered.'}
                </Typography>

                <Stack direction="row" justifyContent="flex-end" gap="10px">
                    <Button
                        variant="outlined"
                        startIcon={<TrashIcon />}
                        onClick={handleSoftDelete}
                        sx={{
                            border: '1px solid #FF3E4A',
                            color: '#FF3E4A',

                            '&:hover': {
                                background: '#FF3E4A',
                                borderColor: '#FF3E4A',
                                color: '#fff',

                                svg: {
                                    path: {
                                        fill: '#fff'
                                    }
                                }
                            }
                        }}
                    >
                        Delete
                    </Button>
                    <Button className="alternate" onClick={handleClose}>
                        {typeOfAction !== 'A' ? 'Keep question' : 'Keep questions'}
                    </Button>
                </Stack>
            </Stack>
        </>
    );
}

export default DeleteResponseTemplate;
